/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import axios from 'axios';

import { getAuthHeader } from 'sarsaparilla/auth';

import type { ExternalMedia } from './media.types';

export function getExternalMedia({
    mediaId,
    signal,
}: {
    mediaId: string;
    signal?: AbortSignal;
}) {
    return axios
        .get<ExternalMedia>(`/api/media/external/${mediaId}`, {
            headers: { Authorization: getAuthHeader() },
            signal,
        })
        .then(({ data }) => data);
}

export function deleteExternalMedia({
    mediaId,
    signal,
}: {
    mediaId: string;
    signal?: AbortSignal;
}) {
    return axios.delete(`/api/media/external/${mediaId}`, {
        headers: { Authorization: getAuthHeader() },
        signal,
    });
}
